<template>
  <div class="usage-funnel-wrapper">
    <div v-if="showExport" class="d-flex justify-end mb-2">
      <ExportButton @click="exportData" tooltip="Export to CSV" />
    </div>

    <v-table density="comfortable">
      <thead>
        <tr class="bg-grey-lighten-3">
          <th class="text-left font-weight-bold">State</th>
          <th class="text-right font-weight-bold">Complete</th>
          <th class="text-right font-weight-bold">Unique User (Usage)</th>
          <th class="text-right font-weight-bold">Pending</th>
          <th class="text-right font-weight-bold">Unique User (Pending)</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data" :key="index" class="hover-row">
          <td class="font-weight-medium">{{ item.stage }}</td>
          <td class="text-right font-weight-bold">{{ formatCount(item.completeForms) }}</td>
          <td class="text-right text-body-2">{{ formatCount(item.completeUniqueUsers) }}</td>
          <td class="text-right text-body-2">{{ formatCount(item.pendingForms) }}</td>
          <td class="text-right text-body-2">{{ formatCount(item.pendingUniqueUsers) }}</td>
        </tr>
      </tbody>
    </v-table>
  </div>
</template>

<script>
import ExportButton from '@/components/TaxDashboard/ExportButton.vue';
import { exportToCSV } from '@/utils/csvExport';

export default {
  name: 'UsageFunnelTable',
  components: {
    ExportButton,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
    showExport: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    // null/undefined = the state has no pending notion (Created / Completed rows) → "-"; 0 is a real count.
    formatCount(value) {
      if (value === null || value === undefined) return '-';
      return value.toLocaleString('en-US');
    },
    exportData() {
      const headers = [
        { key: 'stage', label: 'State' },
        { key: 'completeForms', label: 'Complete' },
        { key: 'completeUniqueUsers', label: 'Unique User (Usage)' },
        { key: 'pendingForms', label: 'Pending' },
        { key: 'pendingUniqueUsers', label: 'Unique User (Pending)' },
      ];
      const rows = this.data.map((item) => ({
        ...item,
        pendingForms: item.pendingForms ?? '-',
        pendingUniqueUsers: item.pendingUniqueUsers ?? '-',
      }));
      exportToCSV(rows, headers, 'usage_funnel_by_form');
    },
  },
};
</script>

<style scoped>
.usage-funnel-wrapper {
  width: 100%;
}

.hover-row {
  transition: background-color 0.2s ease;
}

.hover-row:hover {
  background-color: rgba(0, 0, 0, 0.02);
}

thead tr th {
  font-size: 0.75rem;
  padding: 12px 8px;
  border-bottom: 2px solid rgba(0, 0, 0, 0.12);
}

tbody tr td {
  padding: 12px 8px;
  font-size: 0.813rem;
}
</style>
